import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { CurrencyFormat, Link } from '@lt/components';

import type { INearestDeparturesBlock } from './types';

export const NearestDeparturesBlock = (props: INearestDeparturesBlock) => {
  const { departures, isMobile } = props;
  const { t } = useTranslation();

  return (
    <Container isMobile={isMobile}>
      <List isMobile={isMobile}>
        {departures.map((departure) => {
          const { link, minPrice, nameForm2 } = departure;
          return (
            <li key={nameForm2}>
              {t('explore.hotels.toursFrom', {
                departure: nameForm2,
              })}
              <Link href={link}>
                {` ${t('filters.prices.from')} `}
                <CurrencyFormat value={minPrice} />
              </Link>
            </li>
          );
        })}
      </List>
    </Container>
  );
};

const Container = styled.div<{ isMobile: boolean }>`
  border-top: 1px solid rgba(216, 214, 204, 0.9);

  padding: 7px 24px 9px 16px;
  font-size: 14px;
  line-height: 16px;

  color: ${({ theme }) => theme.colors.blackLight};

  ${({ isMobile }) =>
    isMobile &&
    `
    padding: 7px 8px 9px;
  `}
`;

const List = styled.ul<{ isMobile: boolean }>`
  padding: 0;
  margin: 0;

  li {
    list-style: none;

    ${({ isMobile }) =>
      isMobile
        ? `
          &:not(:first-child) {
            margin-top: 4px;
          }
        `
        : `
          display: inline-block;
          margin-right: 24px;
    `}
  }
`;
